module.exports = __webpack_public_path__ + "static/media/app-11@2x.c661365a.png";